// extracted by mini-css-extract-plugin
module.exports = {"container":"MapLegend__container","containerItem":"MapLegend__containerItem"};